import * as React from 'react';
import { Checkbox } from 'antd';

export interface ICheckboxFieldProps {
    label: string | React.ReactNode;
    value?: string | number | boolean;
    className?: string;
    checked?: boolean;
    disabled?: boolean;
    onChange?: (event: { target: { checked: boolean } }) => void;
}

export const CheckboxField = (props: ICheckboxFieldProps) => {
    return (
        <Checkbox className={props.className} value={props.value} {...(props.checked !== undefined ? { checked: props.checked } : {})} disabled={props.disabled} onChange ={props.onChange}>{props.label}</Checkbox>
    );
};
